import { baseApi } from "@/services/base-api";
import type { Product } from "@/features/marketplace/types/product";

/**
 * Resource-based, matching docs/api/api-design.md's own convention
 * ("POST /products", never "POST /createProduct") even though the doc
 * doesn't enumerate wishlist routes itself — `favorites` is a documented
 * collection (docs/database/collections.md), just without a spelled-out
 * API. `GET /wishlist` returns full `Product` objects, not bare IDs: the
 * Wishlist page needs the whole card, and Home/Search reuse the same query
 * (same cache entry) just to know *which* ids are favorited.
 */
export const wishlistApi = {
  getWishlist: () => baseApi.get<Product[]>("/wishlist"),
  addToWishlist: (productId: string) => baseApi.post<void>(`/wishlist/${productId}`),
  removeFromWishlist: (productId: string) => baseApi.delete<void>(`/wishlist/${productId}`),
};
